import { render, staticRenderFns } from "./FeesEdit.vue?vue&type=template&id=5e5c2c45&scoped=true&"
import script from "./FeesEdit.vue?vue&type=script&lang=js&"
export * from "./FeesEdit.vue?vue&type=script&lang=js&"
import style0 from "./FeesEdit.vue?vue&type=style&index=0&id=5e5c2c45&scoped=true&lang=css&"
import style1 from "./FeesEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c2c45",
  null
  
)

export default component.exports